// extracted by mini-css-extract-plugin
export var legendIndicator = "_92-1";
export var legendRight = "_92-0";